import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bf3b141"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "select-wrap"
}
const _hoisted_2 = { class: "selector" }
const _hoisted_3 = { class: "icon" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "selector" }
const _hoisted_6 = { class: "icon" }

import { computed, onMounted, onUnmounted, ref } from 'vue'
import Popover from './Popover.vue'

interface SelectOption {
  label: string
  value: string | number
  disabled?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Select',
  props: {
    value: {},
    options: {},
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:value"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const showLabel = computed(() => {
  return props.options.find(item => item.value === props.value)?.label || props.value
})

const emit = __emit

const popoverVisible = ref(false)
const selectRef = ref<HTMLElement>()
const width = ref(0)

const updateWidth = () => {
  if (!selectRef.value) return
  width.value = selectRef.value.clientWidth
}
const resizeObserver = new ResizeObserver(updateWidth)
onMounted(() => {
  if (!selectRef.value) return
  resizeObserver.observe(selectRef.value)
})
onUnmounted(() => {
  if (!selectRef.value) return
  resizeObserver.unobserve(selectRef.value)
})

const handleSelect = (option: SelectOption) => {
  if (option.disabled) return

  emit('update:value', option.value)
  popoverVisible.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_IconDown = _resolveComponent("IconDown")!

  return (_ctx.disabled)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "select disabled",
          ref_key: "selectRef",
          ref: selectRef
        }, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.value), 1),
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "icon", {}, () => [
              _createVNode(_component_IconDown, { size: 14 })
            ])
          ])
        ], 512)
      ]))
    : (_openBlock(), _createBlock(Popover, {
        key: 1,
        class: "select-wrap",
        trigger: "click",
        value: popoverVisible.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((popoverVisible).value = $event)),
        placement: "bottom",
        contentStyle: {
      padding: 0,
      boxShadow: '0 6px 16px 0 rgba(0, 0, 0, 0.08)',
    }
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", {
            class: "options",
            style: _normalizeStyle({ width: width.value + 2 + 'px' })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["option", {
            'disabled': option.disabled,
            'selected': option.value === _ctx.value,
          }]),
                key: option.value,
                onClick: ($event: any) => (handleSelect(option))
              }, _toDisplayString(option.label), 11, _hoisted_4))
            }), 128))
          ], 4)
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "select",
            ref_key: "selectRef",
            ref: selectRef
          }, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(showLabel.value), 1),
            _createElementVNode("div", _hoisted_6, [
              _renderSlot(_ctx.$slots, "icon", {}, () => [
                _createVNode(_component_IconDown, { size: 14 })
              ])
            ])
          ], 512)
        ]),
        _: 3
      }, 8, ["value", "contentStyle"]))
}
}

})